import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getBaseURL } from "../../services/api";
import { ToastProvider, useToast } from "./AdminToast";
import { S, COLORS, GLOBAL_ADMIN_CSS } from "./adminStyles";

const API_URL = getBaseURL();

const GoaLeaderboardInner = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("adminToken");
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (!token) navigate("/winrox11-super-admin");
    else fetchLeaderboard();
  }, [token, navigate]);

  const fetchLeaderboard = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/admin/goa-leaderboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLeaderboard(res.data);
    } catch (err) {
      toast.error("Failed to load leaderboard.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <style>{GLOBAL_ADMIN_CSS}</style>
      <button onClick={() => navigate("/winrox11-super-admin/dashboard")} style={S.backBtn}>← Back to Dashboard</button>

      <div style={S.topBar}>
        <div>
          <div style={S.pageTitle}>🏝️ Goa Trip Leaderboard</div>
          <div style={S.pageSubtitle}>Top referrers selected for the Goa vacation</div>
        </div>
        <button onClick={fetchLeaderboard} style={{ ...S.btnPrimary, width: "auto", padding: "10px 20px" }}>
          🔄 Refresh
        </button>
      </div>

      {loading ? (
        <div style={S.loading}>Loading leaderboard...</div>
      ) : (
        <div style={{ background: COLORS.card, border: `1px solid ${COLORS.cardBorder}`, borderRadius: "16px", overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px" }}>
              <thead>
                <tr style={{ background: COLORS.inputBg }}>
                  <th style={{ padding: "14px 16px", fontSize: "10px", fontWeight: 700, color: COLORS.textMuted, letterSpacing: "1px", textTransform: "uppercase", textAlign: "left" }}>Rank</th>
                  <th style={{ padding: "14px 16px", fontSize: "10px", fontWeight: 700, color: COLORS.textMuted, letterSpacing: "1px", textTransform: "uppercase", textAlign: "left" }}>User</th>
                  <th style={{ padding: "14px 16px", fontSize: "10px", fontWeight: 700, color: COLORS.textMuted, letterSpacing: "1px", textTransform: "uppercase", textAlign: "center" }}>Referrals</th>
                  <th style={{ padding: "14px 16px", fontSize: "10px", fontWeight: 700, color: COLORS.textMuted, letterSpacing: "1px", textTransform: "uppercase", textAlign: "right" }}>Total Referral Deposits</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.length === 0 ? (
                  <tr><td colSpan="4" style={{ padding: "40px", textAlign: "center", color: COLORS.textMuted }}>No referral activity found yet.</td></tr>
                ) : (
                  leaderboard.map((user, idx) => (
                    <tr 
                      key={user.id} 
                      className="admin-row-hover"
                      style={{ 
                        borderBottom: `1px solid ${COLORS.cardBorder}`,
                        background: idx < 3 ? `${COLORS.amber}05` : "transparent"
                      }}
                    >
                      <td style={{ padding: "14px 16px" }}>
                        <span style={{ 
                          fontSize: idx < 3 ? "20px" : "14px", 
                          fontWeight: 800,
                          color: idx === 0 ? COLORS.amber : idx === 1 ? "#cbd5e1" : idx === 2 ? "#cd7f32" : COLORS.textMuted 
                        }}>
                          {idx === 0 ? "🥇" : idx === 1 ? "🥈" : idx === 2 ? "🥉" : `#${idx + 1}`}
                        </span>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <div style={{ fontWeight: 700, color: COLORS.text }}>{user.first_name} {user.last_name}</div>
                        <div style={{ fontSize: "11px", color: COLORS.textMuted }}>ID: #{user.id} • {user.mobile}</div>
                      </td>
                      <td style={{ padding: "14px 16px", textAlign: "center" }}>
                        <div style={{ fontSize: "16px", fontWeight: 800, color: COLORS.indigo }}>{user.referral_count}</div>
                        <div style={{ fontSize: "9px", color: COLORS.textMuted, fontWeight: 700, textTransform: "uppercase" }}>Users</div>
                      </td>
                      <td style={{ padding: "14px 16px", textAlign: "right" }}>
                        <div style={{ fontSize: "18px", fontWeight: 800, color: COLORS.green }}>₹{user.referral_deposits.toLocaleString("en-IN")}</div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div style={{ marginTop: "24px", padding: "20px", background: COLORS.indigo + "10", border: `1px solid ${COLORS.indigo}20`, borderRadius: "16px" }}>
        <div style={{ display: "flex", gap: "12px" }}>
          <div style={{ fontSize: "20px" }}>ℹ️</div>
          <div>
            <div style={{ fontSize: "14px", fontWeight: 700, color: COLORS.text, marginBottom: "4px" }}>Selection Criteria</div>
            <div style={{ fontSize: "12px", color: COLORS.textMid, lineHeight: "1.5" }}>
              Ranking is based on <strong>Total Referral Deposits</strong> (sum of all wallet additions by referred users) 
              followed by the total number of successful referrals. Top users are automatically invited to the annual Goa Trip.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const GoaLeaderboard = () => (
  <ToastProvider>
    <GoaLeaderboardInner />
  </ToastProvider>
);

export default GoaLeaderboard;
